import { addDays } from 'date-fns';

import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

export const yearForCalculation = 2025;

export const getInterval = (
  selectedMonth: number,
  selectedDate: number,
): {
  start: { date: number; month: number };
  end: { date: number; month: number };
} => {
  const date = new Date(yearForCalculation, selectedMonth, selectedDate);
  const dateOfStartOfInterval = addDays(date, 1);

  return {
    start: {
      date: dateOfStartOfInterval.getDate(),
      month: dateOfStartOfInterval.getMonth(),
    },
    end: {
      date: date.getDate(),
      month: date.getMonth(),
    },
  };
};

export const getIntervalLabel = (
  start: { date: number; month: number },
  end: { date: number; month: number },
  monthOptionsMap: string[],
  t: TGlobalFunctionTyped,
) => {
  // Leap year case
  if (end.month === 1 && end.date === 28) {
    return `${monthOptionsMap[start.month]} ${start.date} - ${monthOptionsMap[end.month]} ${end.date} / ${monthOptionsMap[end.month]} ${end.date + 1} ${t('bookkeep.settings.spanishDpr.dateSelector.leapYearSelectedPostfix')}`;
  }
  return `${monthOptionsMap[start.month]} ${start.date} - ${monthOptionsMap[end.month]} ${end.date}`;
};
